import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BookOpenIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

// Layout
import LayoutWithOutNavBar from '../../components/layout/LayoutWithOutNavBar';

const RegisterSuccessPage = () => {
  const location = useLocation();
  const email = location.state?.email || 'deine E-Mail-Adresse';

  // Google Ads Conversion-Tracking
  useEffect(() => {
    // Google Ads Conversion Tracking mit der korrekten ID
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-16899827592/registration_complete',
        'event_callback': function() {
          console.log('Conversion tracked successfully');
        }
      });
    }
    
    // Facebook Pixel (falls vorhanden)
    if (window.fbq) {
      window.fbq('track', 'CompleteRegistration');
    }
    
    // Google Analytics Event
    if (window.gtag) {
      window.gtag('event', 'sign_up', {
        'method': 'email'
      });
    }
  }, []);

  return (
    <LayoutWithOutNavBar>
      <div className="min-h-screen bg-base-200">
        <div className="container mx-auto px-4 py-8 max-w-7xl">
          <Link
            to="/"
            className="btn btn-ghost btn-sm gap-2 mb-8 hover:bg-base-300"
          >
            <ArrowLeftIcon className="w-4 h-4" />
            Zurück
          </Link>

          <div className="flex flex-col items-center justify-center">
            {/* Branding Section */}
            <div className="text-center mb-8">
              <BookOpenIcon className="w-12 h-12 text-primary mx-auto mb-4" />
              <h1 className="text-3xl font-bold">
                Mein-SKS
              </h1>
            </div>

            {/* Success Card */}
            <div className="card w-full max-w-md bg-base-100 shadow-lg">
              <div className="card-body text-center space-y-6">
                <div className="flex justify-center">
                  <div className="rounded-full bg-success/10 p-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>

                <div className="space-y-4">
                  <h2 className="text-xl font-bold">Fast geschafft!</h2>
                  <p className="text-base-content/70">
                    Wir haben dir eine E-Mail an <span className="font-medium">{email}</span> geschickt. 
                    Bitte bestätige deine E-Mail-Adresse.
                  </p>
                </div>

                <Link to="/login" className="btn btn-primary w-full">
                  Weiter zum Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutWithOutNavBar>
  );
};

export default RegisterSuccessPage; 